import PropTypes from 'prop-types'
import React from 'react'
import { v4 as UUID } from 'uuid'
import styles from './input.module.scss'

const Input = React.forwardRef(
  (
    {
      label,
      prefix,
      suffix,
      error,
      id = UUID(),
      inputContainerClass = '',
      className = '',
      inputClass = '',
      required,
      ...rest
    },
    ref
  ) => {
    const inputPadding = {}
    const asteriskTemplate = <b className={`${styles.asterisk}`}></b>

    let prefixTemplate = ''
    let suffixTemplate = ''

    if (prefix) {
      inputPadding.paddingLeft = prefix.width
      prefixTemplate = (
        <div
          className={styles.input__prefix}
          style={{ marginRight: `-${prefix.width}`, width: prefix.width }}
        >
          {prefix.template}
        </div>
      )
    }

    if (suffix) {
      inputPadding.paddingRight = suffix.width
      suffixTemplate = (
        <div
          className={styles.input__suffix}
          style={{ marginLeft: `-${suffix.width}`, width: suffix.width }}
        >
          {suffix.template}
        </div>
      )
    }

    const errorClass = error ? styles.error : ''

    return (
      <div className={`${styles.input} ${inputContainerClass}`}>
        <label htmlFor={id}>
          {label}
          {required && asteriskTemplate}
        </label>
        <div className={`${styles.input__container} ${className}`}>
          {prefixTemplate}
          <input
            ref={ref}
            id={id}
            className={`${inputClass} ${errorClass}`}
            style={inputPadding}
            {...rest}
          />
          {suffixTemplate}
        </div>
      </div>
    )
  }
)

Input.displayName = 'Input'

Input.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  inputContainerClass: PropTypes.string,
  inputClass: PropTypes.string,
  error: PropTypes.string,
  prefix: PropTypes.shape({ width: PropTypes.string, template: PropTypes.object }),
  suffix: PropTypes.shape({ width: PropTypes.string, template: PropTypes.object }),
  required: PropTypes.bool,
}

export { Input }
